<div [ngClass]="{ 'form-row': to?.className === 'xilo-input' }">
  <div [ngClass]="{ 'form-item': to?.className === 'xilo-input' }">
    <p *ngIf="!hasLink(to?.link)" [ngStyle]="styleText()">{{ model?.classKey ? model.classKey : to?.label }}</p>
    <a [href]="to.link" target="_blank" *ngIf="hasLink(to?.link)" [ngStyle]="styleText()">{{ model?.classKey ? model.classKey : to?.label }}</a>
  </div>
</div>
